import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";
import CanvasAnimation from "../../Components/CanvasItems";

const ChooseDbType = () => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const { project_id } = useParams()
    const user_id = sessionStorage.getItem("user_id");

    const goBack = () => {
        navigate(`/project_panel/${project_id}/databases`);
    };

    return (
        <div className="choose_db_type_container fade-in">
            <p className="new_section_main_view_title">
                <i className="fa-solid fa-chevron-left" onClick={goBack}></i>Choose your database
            </p>
            <p className="new_section_main_view_subtitle">
                Select the database that fits your project
            </p>


            <div className="choose_db_type_cards">
                <div className="choose_db_type_card" onClick={() => navigate(`/project_panel/${project_id}/databases/new_database_nosql`)}>
                    <p className="choose_db_type_card_title">Erioon NoSQL</p>
                    <p className="choose_db_type_card_desc">
                        Built for speed and scalability, Erioons custom NoSQL engine handles massive datasets effortlessly and supports real-time data operations.
                    </p>
                    <i className="fa-solid fa-chevron-right"></i>
                    <div className="canvas_db_type_card_cont">
                        <CanvasAnimation type={"json"} />
                    </div>
                </div>
                {/* <div className="choose_db_type_card not_available" onClick={() => navigate(`/project_panel/${project_id}/databases/new_database_sql`)}> */}
                <div className="choose_db_type_card not_available">
                    <p className="choose_db_type_card_title">Erioon SQL</p>
                    <p className="choose_db_type_card_desc">
                        Deploy and manage popular SQL databases in minutes. Perfect for structured data and transactional workloads.
                    </p>
                    {/* <i className="fa-solid fa-chevron-right"></i> */}
                    <div className="canvas_db_type_card_cont">
                        <CanvasAnimation type={"sqltable"} />
                    </div>
                    <p className="choose_db_type_card_desc">This section is not available for demo users</p>
                </div>
            </div>
        </div>
    )
}

export default ChooseDbType;
